import React from 'react';

// - Add '.fill' to all body classes.
// - Add '.tail' <g> around tail. Remember to add '.fill' to tail shape so that:
	// <g .tail > <path .fill /> </g>

export default function Bodies() {
	return (
		<g>
			<g className="tail">
				<path className="fill" fill="#F7EDE8" d="M354.46661,313.76791c1.9939,1.15649,4.04602,2.1084,6.26581,2.77222
					c2.23157,0.58716,4.65857,0.87744,7.29053,0.84155c2.6264-0.00708,5.47021-0.51001,8.39771-1.27612
					c2.92963-0.77368,5.95776-1.8728,8.97736-3.3042c3.02319-1.41138,6.05469-3.07422,9.04443-4.94849
					c2.98126-1.89453,5.92493-3.97925,8.80298-6.21875c2.87811-2.23926,5.69153-4.63452,8.41376-7.14526
					c1.36627-1.25098,2.6958-2.54175,4.00366-3.84448c0.65265-0.65356,1.29272-1.30957,1.92371-1.96826l1.74194-1.85571
					l0.55243-0.58862c3.77948-4.02637,10.10742-4.22656,14.13379-0.44702c3.55316,3.33545,4.12286,8.65771,1.61127,12.62915
					l-0.96118,1.52222l-0.89838,1.38696c-0.59875,0.90723-1.20374,1.80469-1.81543,2.6897
					c-1.22754,1.76758-2.47626,3.5127-3.77307,5.22241c-2.58417,3.42773-5.30975,6.7644-8.20764,10.00806
					c-5.79279,6.48291-12.2511,12.63037-19.8476,18.04272c-3.77698,2.71875-7.89362,5.20801-12.36639,7.36523
					c-4.47223,2.14331-9.28955,4.01978-14.55084,5.17578c-5.23425,1.17798-10.82239,1.75195-16.51678,1.47827
					c-5.69073-0.34326-11.35718-1.52344-16.75049-3.35474l-0.86835-0.29468c-9.7807-3.32104-15.01733-13.94214-11.69635-23.7229
					c3.32104-9.78076,13.94208-15.01733,23.72278-11.69629C352.25708,312.63071,353.44055,313.18173,354.46661,313.76791z" />
			</g>
			<path className="fill" fill="#F7EDE8" d="M224.85794,216.41782c-36.03488,0-57.54167,13.21263-61.81805,49.78073
				c-4.30435,36.80725,19.65471,47.41922,57.5524,63.71628c12.89163,5.54373,130.49991,55.82355,132.25906-0.90277
				C354.54349,274.44696,271.23871,233.87971,224.85794,216.41782z" />
			<path className="fill" fill="#F7EDE8" d="M185.32265,252.65935c-11.18762-1.25537-21.27417,6.79588-22.52954,17.98338
				l-9.42757,83.68814c-1.25531,11.1875,6.79596,19.27258,17.98358,20.52795c11.18756,1.25537,21.27411-4.79431,22.52948-15.98181
				l9.42757-83.68814C204.56154,264.00113,196.51021,253.91472,185.32265,252.65935z" />
			<path className="fill fill--alt" fill="#B78A76" d="M193.28119,362.48071c-1.39595,10.71671-10.06859,13.19708-22.48885,13.19708
				c-12.42024,0-23.48965-1.38904-23.48965-12.19629c0-8.10541,6.22655-15.02548,14.57961-17.97891
				c2.78435-0.9845,5.80499-1.52823,8.91005-1.52823c3.5649,0,7.05083,0.64352,10.1765,1.81403
				C188.73314,348.69601,194.27446,354.85547,193.28119,362.48071z" />
			<path className="fill" fill="#F7EDE8" d="M239.59492,252.65935c-11.18762-1.25537-21.27417,6.79588-22.52954,17.98338
				l-9.42758,83.68814c-1.25531,11.1875,6.79596,19.27258,17.98358,20.52795c11.18756,1.25537,21.27411-4.79431,22.52948-15.98181
				l9.42757-83.68814C258.8338,264.00113,250.78249,253.91472,239.59492,252.65935z" />
			<path className="fill fill--alt" fill="#B78A76" d="M247.55345,362.48071c-1.39595,10.71671-10.06859,13.19708-22.48885,13.19708
				c-12.42024,0-23.48964-1.38904-23.48964-12.19629c0-10.80722,11.0694-19.50714,23.48964-19.50714
				C237.48486,343.97437,248.94659,351.78577,247.55345,362.48071z" />
			<path className="fill fill--alt" fill="#B78A76" d="M336.13098,293.28613c-28.10754-16.89716-66.83844,6.17871-50.85712,51.55591
				c-8.83398,2.02393-17.22394,4.2341-20.24677,13.79193c-1.15604,3.65549-0.79999,6.72189,0.216,9.20038
				c1.98541,4.84323,6.89575,7.84344,12.13,7.84344h13.0043h0.48563h35.13348c20.9079,0,23.36536-21.37454,26.30151-41.50098
				C354.28412,320.56305,350.79184,302.09967,336.13098,293.28613z" />
			<path className="fill fill--alt" fill="#B78A76" d="M265.21698,279.28073c-0.91028-6.53882-6.68173-15.63458-15.25095-15.78094
				c-8.5692-0.14633-18.46236,6.72153-19.83272,15.18173c-2.17659,13.43774,17.60139,25.49323,27.85793,21.59344
				C266.0022,297.22897,266.23395,286.58603,265.21698,279.28073z" />
			<path className="fill fill--alt" fill="#B78A76" d="M319.93579,269.12598c-13.36566-11.59082-29.43048-21.79028-45.53638-30.39966
				c-6.25592,13.63672-5.10388,34.99976,8.3667,42.24243c11.1853,6.01416,28.18018,0.56934,35.73206-9.64087
				C319.02637,270.61377,319.50195,269.8772,319.93579,269.12598z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/ClassicDoggo/Bodies.js